import * as TYPE from '../../TYPE';
export var showLogic = TYPE.logic.makeTAddIsNotMoralOrIgnored({});
export var showTrueFalseLogic = TYPE.logic.makeTAddIsNotMoralOrIgnored({
    truthy: {
        result: true,
    },
    falsy: {
        result: false,
    },
});
